'use strict';
import keyboardUtils from './keyboardUtils.ts';

const a11yUtils = {
    focusedElementsBeforeModal: [],
    focusableElements: [],
    focusableSelectors: 'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"]',

    focusTrapOn(modal) {
        this.focusedElementsBeforeModal.push(document.activeElement);
        this.focusableElements = this.getAllFocusableElements(modal);
        if (this.focusableElements[0]) {
            this.focusableElements[0].focus();
        }
        modal.addEventListener('keydown', (e) => this.trapTabKey(e));
    },

    focusTrapUpdate(modal) {
        this.focusableElements = this.getAllFocusableElements(modal);
    },

    focusTrapOff() {
        if (this.focusedElementsBeforeModal.length === 0) {
            return;
        }
        let focusedElementNow = this.focusedElementsBeforeModal[this.focusedElementsBeforeModal.length - 1];
        focusedElementNow.focus();
        this.focusedElementsBeforeModal.pop();
    },

    trapTabKey(e) {
        if (keyboardUtils.isTabKey(e)) {
            if (e.shiftKey) {
                // + SHIFT
                if (document.activeElement === this.focusableElements[0]) {
                    e.preventDefault();
                    this.focusableElements[this.focusableElements.length - 1].focus();
                }
            } else {
                if (document.activeElement === this.focusableElements[this.focusableElements.length - 1]) {
                    e.preventDefault();
                    this.focusableElements[0].focus();
                }
            }
        }
    },

    getFirstFocusable(parent) {
        return this.getAllFocusableElements(parent)[0];
    },

    getAllFocusableElements(parent) {
        return [...parent.querySelectorAll(this.focusableSelectors)].filter((element) => {
            return !!!this.isHiddenElement(element);
        });
    },

    isHiddenElement(el) {
        return el.offsetWidth === 0 || el.offsetHeight === 0 || window.getComputedStyle(el, null).getPropertyValue('visibility') === 'hidden';
    },

    toggleEveryTabindex(wrapper, value = -1) {
        if (!wrapper) {
            console.error('Wrapper element is needed in toggleEveryTabindex()');
            return;
        }
        this.getAllFocusableElements(wrapper).forEach((el) => {
            el.setAttribute('tabindex', value);
        });
    },
};
export default a11yUtils;
